const defaultFields = {
  exploitation: {
    visible: true, order: 1, locked: true, maxWidth: 45, minWidth: 45, defaultMin: 45, defaultWidth: 45
  },
  name: {
    visible: true, order: 2, locked: true, maxWidth: 400, minWidth: 200, defaultMin: 200, defaultWidth: 380
  },
  description: {
    visible: true, order: 3, maxWidth: 400, minWidth: 150, defaultMin: 150, defaultWidth: 260
  },
  references: {
    visible: true, order: 4, maxWidth: 350, minWidth: 175, defaultMin: 175, defaultWidth: 220
  },
  resolution: {
    visible: true, order: 5, maxWidth: 350, minWidth: 175, defaultMin: 175, defaultWidth: 260
  },
  policyviolations: {
    visible: true, order: 6, maxWidth: 350, minWidth: 175, defaultMin: 175, defaultWidth: 220
  },
  creator_id: {
    visible: true, order: 7, maxWidth: 150, minWidth: 150, defaultMin: 150, defaultWidth: 150
  },
  create_date: {
    visible: true, order: 8, maxWidth: 180, minWidth: 120, defaultMin: 120, defaultWidth: 150
  }
};

export default defaultFields;
